package music.jammers.client.shared.admin.presentation.viewmodel

import music.jammers.client.shared.admin.presentation.model.SettingItem

data class AdminSettingsPageState(
    val settingList: List<SettingItem> = emptyList()
)